<template>
  <ul class="radio-wrap">
    <li
      v-for="(item, index) in option"
      :key="index"
      class="item"
      :class="{ active: item.value === modelValue }"
      @click="handleClick(item)"
    >
      {{ item.label }}
    </li>
  </ul>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    option: {
      type: Array
    },

    modelValue: {
      type: Number,
      default: 0
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const curEnum = ref(props.modelValue);

    const handleClick = i => {
      emit('update:modelValue', i.value);
    };
    return {
      handleClick,
      curEnum
    };
  }
});
</script>

<style scoped lang="less">
.radio-wrap {
  display: flex;
  .item {
    height: 36px;
    background: var(--card-background-color);
    border-radius: 8px 8px 8px 8px;
    padding: 0 18px;
    line-height: 36px;
    text-align: center;
    color: var(--font-color);
    margin-right: 12px;
    cursor: pointer;
    &.active {
      background: var(--secondary-background-color);
      color: var(--theme-color);
    }
  }
}
</style>
